export default __webpack_public_path__ + "static/media/promo.d70faac4.svg";